module.exports = __webpack_public_path__ + "static/media/nexttel-background.16cd208b.png";